// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateComment-cls1_L6B","cls2":"CreateComment-cls2_eP_ CreateComment-cls1_L6B"};